"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var url_1 = __importDefault(require("url"));
var lodash_1 = require("lodash");
var parseQuery = function (query) {
    var e_1, _a;
    var result = {};
    if (!query) {
        return result;
    }
    try {
        for (var _b = __values((0, lodash_1.split)(query, "&")), _c = _b.next(); !_c.done; _c = _b.next()) {
            var queryParam = _c.value;
            var _d = __read((0, lodash_1.split)(queryParam, "="), 2), key = _d[0], value = _d[1];
            result[key] = value;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
};
var removeSlashes = function (str) { return (0, lodash_1.replace)(str, "/", ""); };
exports.default = (function (resourceUrl) {
    var urlObj = url_1.default.parse(resourceUrl);
    var path = urlObj.pathname;
    if (urlObj.hostname === "youtu.be") {
        return removeSlashes(path);
    }
    if (urlObj.hostname && ["youtube.com", "www.youtube.com"].includes(urlObj.hostname)) {
        var _path = path;
        if (_path.match(/^\/embed\//) || _path.match(/^\/v\//)) {
            return _path.split("/")[2];
        }
        else if (_path.match(/^\/watch/)) {
            return parseQuery(urlObj.query).v;
        }
    }
    return "";
});
